<div class="relative overflow-x-auto py-4">
  <h1 class="text-2xl font-semibold text-gray-800 dark:text-blue py-4">
    Owner List
  </h1>
  <div>
    <app-owner-filter/>
  </div>
  <div class="flex justify-end py-4">
    <a
      routerLink="/owner/create"
      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    >
      Create Owner
    </a>
  </div>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
      <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
              <th scope="col" class="px-6 py-3">
                  Id
              </th>
              <th scope="col" class="px-6 py-3">
                  First Name
              </th>
              <th scope="col" class="px-6 py-3">
                  Last Name
              </th>
              <th scope="col" class="px-6 py-3">
                Fathr Name
              </th>
              <th scope="col" class="px-6 py-3">
                  Date Of Birth
              </th>
              <th scope="col" class="px-6 py-3">
                Gender
              </th>
              <th scope="col" class="px-6 py-3">
                   Qualification
              </th>
              <th scope="col" class="px-6 py-3">
                   Phone Number
              </th>
              <th scope="col" class="px-6 py-3">
                   Mobile Number
               </th>
             <th scope="col" class="px-6 py-3">
                 Alternate Mobile Number
            </th>
            <th scope="col" class="px-6 py-3">
                Email
            </th>
            <th scope="col" class="px-6 py-3">
              Website
            </th>
            <th scope="col" class="px-6 py-3">
              Ecomm Website
            </th>
            <th scope="col" class="px-6 py-3">
              Since
            </th>
            <th scope="col" class="px-6 py-3">
              Referance
            </th>
            <th scope="col" class="px-6 py-3">
              Last Login
            </th>
            <th scope="col" class="px-6 py-3">
              Active Period
            </th>
            <th scope="col" class="px-6 py-3">
              Active Contact
            </th>
            <th scope="col" class="px-6 py-3">
              OTP
            </th>
            <th scope="col" class="px-6 py-3">
              Other Information
            </th>
            <th scope="col" class="px-6 py-3">
              Image ID
            </th>
            <th scope="col" class="px-6 py-3">
              Thumb Check
            </th>
            <th scope="col" class="px-6 py-3">
              Referal Code
            </th>
            <th scope="col" class="px-6 py-3">
              Last Column
            </th>
              <th scope="col" class="px-6 py-3">
                  Action
              </th>
          </tr>
      </thead>
      <tbody>
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200"
            *ngFor="let owner of owners"
          >
              <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {{owner.id}}
              </th>
              <td class="px-6 py-4">
                  {{owner.fname}}
              </td>
              <td class="px-6 py-4">
                  {{owner.lname}}
              </td>
              <td class="px-6 py-4">
                 {{owner.father_name}}
              </td>
              <td class="px-6 py-4">
                 {{owner.dob}}
              </td>
              <td class="px-6 py-4">
                  {{owner.sex}}
              </td>
              <td class="px-6 py-4">
                {{owner.qualification}}
              </td>

              <td class="px-6 py-4">
                {{owner.phone}}
            </td>
            <td class="px-6 py-4">
              {{owner.mobile}}
          </td>
          <td class="px-6 py-4">
              {{owner.sec_mobile}}
          </td>
          <td class="px-6 py-4">
              {{owner.email}}
          </td>
                <td class="px-6 py-4">
                  {{owner.website}}
              </td>
              <td class="px-6 py-4">
                {{owner.ecomm_website}}
            </td>
            <td class="px-6 py-4">
              {{owner.since}}
          </td>
          <td class="px-6 py-4">
            {{owner.ref}}
          </td>
          <td class="px-6 py-4">
            {{owner.last_login}}
          </td>
          <td class="px-6 py-4">
            {{owner.act_period}}
          </td>
          <td class="px-6 py-4">
            {{owner.act_contact}}
          </td>
          <td class="px-6 py-4">
            {{owner.other_info}}
          </td>
          <td class="px-6 py-4">
            {{owner.image_id}}
          </td>
          <td class="px-6 py-4">
            {{owner.thumb_check}}
          </td>
          <td class="px-6 py-4">
            {{owner.refferal_code}}
          </td>
          <td class="px-6 py-4">
            {{owner.last_column}}
          </td>
              <td class="px-6 py-4">
                <a routerLink="/owner/{{owner.id}}/edit">
                  edit
                </a>
                <a routerLink="" (click)="onDeleteOwner($event,owner.id)">
                  Delete
                </a>
                <a routerLink="/owner/{{owner.id}}/singleowner">
                  Details
                </a>
              </td>
          </tr>

      </tbody>
  </table>
</div>
